import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { editUser } from "../Redux/User/userSlice"; // Action to update user profile
// import { updateProfileInFirestore } from "../firebase.config"; // Firestore update function
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { auth, db, sendPasswordReset } from "../firebase.config";

import { FaExclamationCircle } from "react-icons/fa";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { setLoading } from "../Redux/Loader/loadingSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { profileValidationSchema } from "../utils/profileValidationSchema";

const ProfilePage = () => {
  const user = useSelector((state) => state.user); // Get user data from Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [storeUser, setStoreUser] = useState({});
  const [editing, setEditing] = useState(false);
  const [resetError, setResetError] = useState("");

  useEffect(() => {
    if (user.loggedIn) {
      dispatch(setLoading(true));
      const getUserData = async () => {
        try {
          const uid = auth.currentUser.uid; // Get the current user's UID from Firebase Authentication

          // Create a Firestore query to find the document where `uid` field matches the logged-in user's UID
          const userQuery = query(
            collection(db, "users"),
            where("uid", "==", uid)
          );
          const querySnapshot = await getDocs(userQuery);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0]; // Assume only one document matches the UID

            // Populate the form fields with the fetched data
            setStoreUser(userDoc.data());
            console.log("userDOC", userDoc.data());
            dispatch(setLoading(false));
          } else {
            console.log("No user found with this UID.");
            dispatch(setLoading(false));
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          dispatch(setLoading(false));
        }
      };

      getUserData();
    } else {
      navigate("/"); // Redirect to login if user is not logged in
    }
  }, [user, navigate]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(profileValidationSchema),
    defaultValues: {
      companyName: storeUser.companyName || "", // Set default empty value if not loaded
      contactEmail: storeUser.contactEmail || "",
      contactFirstName: storeUser.contactFirstName || "",
      contactLastName: storeUser.contactLastName || "",
    },
  });

  useEffect(() => {
    if (storeUser) {
      // Dynamically set form fields when storeUser changes
      setValue("companyName", storeUser.companyName);
      setValue("contactEmail", storeUser.contactEmail);
      setValue("contactFirstName", storeUser.contactFirstName);
      setValue("contactLastName", storeUser.contactLastName);
    }
  }, [storeUser, setValue]);

  const onSubmit = async (data, status) => {
    console.log(data);
    console.log(errors);
  };

  const resetPassword = async () => {
    try {
      await sendPasswordReset(storeUser.contactEmail); // Send reset email to the provided email

      setResetError("");
    } catch (err) {
      setResetError(err.message); // If error occurs, show error message
    }
  };

  return (
    <>
      {!editing ? (
        <div className="profile-page">
          <h2>Profile</h2>
          <h3>Company Name</h3>
          <p>{storeUser.companyName}</p>
          <h3>Contact Name</h3>
          <p>{`${storeUser.contactFirstName} ${storeUser.contactLastName}`}</p>

          <h3>Contact Email</h3>
          <p>{`${storeUser.contactEmail}`}</p>
          <button onClick={() => setEditing(true)}>Edit Profile</button>
          <button onClick={resetPassword}>Rest Password</button>
        </div>
      ) : (
        <form
          className="new-exhibit-form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <div
            className={
              errors.companyName
                ? "job-form-input-container error"
                : "job-form-input-container"
            }
          >
            {errors.companyName && (
              <p className="error-message">
                <span style={{ marginRight: "5px" }}>
                  <FaExclamationCircle />
                </span>
                {errors.companyName.message}
              </p>
            )}
            <div className="job-form-input">
              <label htmlFor="companyName">Company Name</label>
              <input
                disabled
                id="companyName"
                type="text"
                cols={35}
                placeholder=""
                className="input"
                {...register("companyName")}
              />
            </div>
          </div>
          <div
            className={
              errors.contactFirstName
                ? "job-form-input-container error"
                : "job-form-input-container"
            }
          >
            {errors.contactFirstName && (
              <p className="error-message">
                <span style={{ marginRight: "5px" }}>
                  <FaExclamationCircle />
                </span>
                {errors.contactFirstName.message}
              </p>
            )}
            <div className="job-form-input">
              <label htmlFor="contactFirstName">Contact First Name</label>
              <input
                id="contactFirstName"
                type="text"
                cols={35}
                placeholder=""
                className="input"
                {...register("contactFirstName")}
              />
            </div>
          </div>
          <div
            className={
              errors.contactLastName
                ? "job-form-input-container error"
                : "job-form-input-container"
            }
          >
            {errors.contactLastName && (
              <p className="error-message">
                <span style={{ marginRight: "5px" }}>
                  <FaExclamationCircle />
                </span>
                {errors.contactLastName.message}
              </p>
            )}
            <div className="job-form-input">
              <label htmlFor="contactLastName">Contact Last Name</label>
              <input
                id="contactLastName"
                type="text"
                cols={35}
                placeholder=""
                className="input"
                {...register("contactLastName")}
              />
            </div>
          </div>
          <div
            className={
              errors.contactEmail
                ? "job-form-input-container error"
                : "job-form-input-container"
            }
          >
            {errors.contactEmail && (
              <p className="error-message">
                <span style={{ marginRight: "5px" }}>
                  <FaExclamationCircle />
                </span>
                {errors.contactEmail.message}
              </p>
            )}
            <div className="job-form-input">
              <label htmlFor="contactEmail">Contact Email</label>
              <input
                id="contactEmail"
                type="text"
                cols={35}
                placeholder=""
                className="input"
                {...register("contactEmail")}
              />
            </div>
          </div>
          <button
            onClick={handleSubmit((data) => onSubmit(data, "In Progress"))}
            type="submit"
            className="submit-btn"
          >
            Save Changes
          </button>
        </form>
      )}
    </>
  );
};

export default ProfilePage;
